import { render, staticRenderFns } from "./SendWindowView.vue?vue&type=template&id=e8248b14&scoped=true&"
import script from "./SendWindowView.vue?vue&type=script&lang=js&"
export * from "./SendWindowView.vue?vue&type=script&lang=js&"
import style0 from "./SendWindowView.vue?vue&type=style&index=0&id=e8248b14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8248b14",
  null
  
)

export default component.exports